import styled from 'styled-components';
import { ErrorComponentWrapStyled } from '@ch/common/components/error/error.styled';
import { colors } from '@ch/common/const/color';
import { GridBreakpointsMediaDown } from '@ch/common/const/grid';

const LayoutStyled = styled.div`
  min-height: calc(100vh - 137px);

  ${ErrorComponentWrapStyled} {
    min-height: calc(100vh - 137px);
  }
`;

export const HeaderTextStyled = styled.div<{ $color?: string }>`
  ${GridBreakpointsMediaDown.lg} {
    display: none;
  }
  margin-left: 24px;
  padding-left: 8px;
  ${({ $color }) => $color && `border-left: 1px solid ${colors[$color]} !important;`}
`;

export default LayoutStyled;
